import Badge from "@mui/material/Badge";
import { ReactNode } from "react";

type NotificationTabProps = {
  children: ReactNode;
  count?: number;
};

export default function NotificationTab({
  children,
  count = 0,
}: NotificationTabProps) {
  return (
    <Badge
      sx={{
        zIndex: 0,
        "& .MuiBadge-anchorOriginTopRight": {
          opacity: 0.7,
        },
      }}
      badgeContent={count}
      color="primary"
    >
      {children}
    </Badge>
  );
}
